import { urls } from 'Constants/Urls'
import { axiosDS } from '@pp/axios'
import { RequestParams, ResponseCatalog } from 'Models'
import {
	CreateOrdersBlackListItem,
	OrdersBlackListCheckInn,
	OrdersBlackListModel,
} from 'Pages/orders'

export const orderBlacklistApi = {
	checkInn: async (inn: string) => {
		const res = await axiosDS().get<OrdersBlackListCheckInn>(
			`${urls.orders.blacklist_main}/check_inn`,
			{
				params: { inn },
			}
		)
		return res.data
	},
	getAll: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<OrdersBlackListModel>>(
			urls.orders.blacklist_main,
			{
				params,
			}
		)
		return res.data
	},
	createOne: async (data: CreateOrdersBlackListItem) => {
		const res = await axiosDS().post<OrdersBlackListModel>(urls.orders.blacklist_main, { data })
		return res.data
	},
	deleteOne: async (id: number) => {
		const res = await axiosDS().delete<OrdersBlackListModel>(`${urls.orders.blacklist_main}/${id}`)
		return res.data
	},
	updateOne: async (id: number, data: CreateOrdersBlackListItem) => {
		const res = await axiosDS().patch<OrdersBlackListModel>(`${urls.orders.blacklist_main}/${id}`, {
			data,
		})
		return res.data
	},
}
